<script>
export default {
  props: {
    value: String,
    mode: { type: String, validator: (val) => ['collection', 'packing', 'chicken_weight'].includes(val) },
    triggerSelectNext: { type: Number },
    label: { type: String, default: () => 'Batch' },
    formGroupClass: { type: String },
    selectBatchText: { type: String, default: () => 'Select batch...' },
  },

  data: () => ({
    batchSummaries: [],
  }),

  computed: {
    availableBatches() {
      return this.batchSummaries
        .filter(x => {
          switch (this.mode) {
            case 'collection': return x.permissions.can_add_collection_record;
            case 'packing': return x.permissions.can_add_packing_record;
            case 'chicken_weight': return x.permissions.can_add_chicken_weight_record;
            default:
              alert(`Unexpected mode ${this.mode}`)
              break;
          }
        });
    },

    selectOptions() {
      return [{ value: '', text: this.selectBatchText }]
        .concat(this.availableBatches.map(x => ({ value: x.name, text: x.name })));
    },

    selectedBatchAgeInWeeks() { return this.value && this.batchSummaryByName(this.value) ? this.calculateAgeInWeeks(this.batchSummaryByName(this.value).age) : undefined },
  },

  watch: {
    triggerSelectNext(to) {
      let selectedIndex = this.selectOptions.findIndex(x => x.value === this.value);
      selectedIndex++;

      var newValue = selectedIndex >= this.selectOptions.length ? '' : this.selectOptions[selectedIndex].value;
      this.$emit('input', newValue)
    },
  },

  methods: {
    batchSummaryByName(name) { return this.batchSummaries.find(x => String(x.name) === String(name)) },

    calculateAgeInWeeks(ageInDays) { return Math.trunc(ageInDays / 7) },
  },
}
</script>

<template>
  <api-loader
    method="get"
    url="v1/layers/batch-summaries"
    @loaded="batchSummaries=$event"
    :show-busy="false"
    :show-error="false">

    <div class="position-relative" slot-scope="{busy, error}">
      <b-form-group :label="label" :class="[selectedBatchAgeInWeeks ? 'mb-0' : '', formGroupClass]" :label-for="`select-${_uid}`">
        <b-form-select
          :value="value"
          @input="$emit('input', $event)"
          @change="$emit('change', $event)"
          :id="`select-${_uid}`"
          :options="selectOptions"
          v-bind="$attrs"
          :disabled="busy"
          plain>
        </b-form-select>
      </b-form-group>

      <div v-if="selectedBatchAgeInWeeks" class="mb-2 text-right"> <small class="text-muted">Age: {{selectedBatchAgeInWeeks}} weeks</small> </div>

      <div v-if="busy||error" class="position-absolute" style="bottom:8px; right:20px;">
        <i v-if="busy" class="fa fa-spinner fa-spin"></i>
        <span v-else-if="error" class="text-danger">{{error}}</span>
      </div>
    </div>
  </api-loader>
</template>



// WEBPACK FOOTER //
// src/layer/components/LayerBatchChooser.vue